import { EJourneys } from '@/context/display';

import { ISetInitialBorrower } from './ISetInitialBorrower';
import { setInitialTestDriveDate } from './setInitialTestDriveDate';
import { setInitialTestDriveTime } from './setInitialTestDriveTime';
import { setLead } from './setLead';

export function setInitialBorrower(
    { leadToken, testDriveDate, testDriveTime }: ISetInitialBorrower,
    initialJourney?: EJourneys
): void {
    setLead(leadToken);
    setInitialTestDriveDate(testDriveDate, initialJourney);
    setInitialTestDriveTime(testDriveTime, initialJourney);
}
